<template>
  <PagesModalComponent
    :closePath="closePath"
    v-if="item"
    :class="$style.root"
  >
    <template #heading>
      <h1
        v-html="item?.label"
        :class="$style.heading"
      />
    </template>

    <CoreTextComponent
      v-if="item?.richText"
      :string="item?.richText"
      :class="$style.richText"
    />
  </PagesModalComponent>
</template>

<script lang="ts" setup>
  const props = defineProps({
    item: {
      type: Object,
      required: true
    },
    closePath: {
      type: String
    }
  })
</script>

<style module>
.root {
  composes: font-default from global;
}

.heading {
  composes: reset-heading font-size-x-large from global;
}

.richText {
  margin-top: var(--unit--default);
}
</style>
